import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StoryHomePage } from './story-home.page';
import { PagesModule } from '../../pages.module';

const routes: Routes = [
  {
    path: '',
    component: StoryHomePage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [StoryHomePage]
})
export class StoryHomePageModule {}
